import { MantineTheme, rem } from "@mantine/core";
import { rgba } from "polished";

import { ThemeComponent } from "./helpers";

const filledGoldenActionIcon = (theme: MantineTheme) => ({
  root: {
    background: theme.colors.golden[0],
    color: theme.colors.white[0],
    "&:hover": {
      background: rgba(theme.colors.golden[0], 0.9),
    },
    "&:focus": {
      background: theme.colors.golden[0],
      color: theme.colors.white[0],
    },
    "&:focus-within": {
      border: "none",
      background: theme.colors.golden[0],
      color: theme.colors.white[0],
    },
    "&:disabled": {
      color: theme.colors.white[0],
      background: theme.colors.grayIce[0],
    },
  },
});

const outlineGoldenActionIcon = (theme: MantineTheme) => ({
  root: {
    color: theme.colors.golden[0],
    background: "transparent",
    border: `1px solid ${theme.colors.golden[0]}`,
    "&:hover": {
      color: theme.colors.golden[0],
      border: `1px solid ${theme.colors.golden[0]}`,
      background: rgba(theme.colors.golden[0], 0.1),
    },
    "&:focus": {
      color: theme.colors.golden[0],
      border: `1px solid ${theme.colors.golden[0]}`,
    },
    "&:disabled": {
      color: theme.colors.grayIce[0],
      border: `1px solid ${theme.colors.grayIce[0]}`,
      background: theme.colors.grayIce[9],
    },
  },
});

export default function actionIconTheme(): ThemeComponent {
  return {
    variants: {
      filledGolden: filledGoldenActionIcon,
      outlineGolden: outlineGoldenActionIcon,
    },
    sizes: {
      m: () => ({
        root: {
          height: rem(44),
          width: rem(44),
          borderRadius: rem(4),
          flexShrink: 0,
        },
      }),
    },
  };
}
